import get from "lodash/get";
import { useResourceDefinition } from "react-admin";
import { NoAccess } from "./noAccess";

export const WithRoute = ({ route, label, render }) => {
  const paths = get(useResourceDefinition(), "options.innerRoutes", []);
  if (!paths.includes(route)) {
    return <NoAccess can={{ route }} label={label} />;
  }

  return render();
};
